import React, { Fragment } from 'react';
import { LI, UL } from '../../../../AbstractElements';

const CommenUL = () => {
  return (
    <Fragment>
      <UL className='flex-row'>
        <LI></LI>
        <LI></LI>
        <LI></LI>
      </UL>
    </Fragment>
  );
};
export default CommenUL;
